import { asyncGetPosts } from '../helpers/posts-helpers';
var PostsToTags = /** @class */ (function () {
    function PostsToTags() {
        this.id = 'posts_to_tags';
        this.alias = 'Posts to Customer Tags';
    }
    PostsToTags.prototype.getData = function (connector, table, done) {
        asyncGetPosts({
            connector: connector,
            table: table,
            done: done,
            body: {
                start: connector.getStartDate(),
                end: connector.getEndDate(),
                fields: ['created_time', 'guid', 'internal.tags'],
                metrics: [],
            },
            rowsFormatter: function (response) {
                var rows = [];
                var posts = response.data || [];
                posts.forEach(function (post) {
                    var _a;
                    var tags = ((_a = post === null || post === void 0 ? void 0 : post.internal) === null || _a === void 0 ? void 0 : _a.tags) || [];
                    var postGuid = post.guid;
                    tags.forEach(function (tag) {
                        rows.push({ guid: postGuid, tag_id: tag.id });
                    });
                });
                return rows;
            },
            requestProgressMessageFormatter: function (count) { return "Checking ".concat(count.toLocaleString(), " posts for tags"); },
        });
    };
    PostsToTags.prototype.getTableInfo = function () {
        return {
            id: this.id,
            alias: this.alias,
            columns: [
                {
                    id: 'guid',
                    dataType: 'string',
                    alias: 'Post GUID',
                    description: 'The native ID of the message prefixed with a Sprout code that represents where this type of message is.',
                },
                {
                    id: 'tag_id',
                    dataType: 'int',
                    alias: 'Tag ID',
                    description: 'The ID used by Sprout to identify this message tag.',
                },
            ],
        };
    };
    return PostsToTags;
}());
export default PostsToTags;
